import CountUp from "react-countup"
import {
  ClickToEditArea,
  WaterTitle,
  WaterUnit,
  WaterValue,
  WaterValueBox,
  WaterWrapper,
} from "./styled"
import PencilIcon from "components/Icons/PencilIcon"
import { useDailyWater } from "features/water/hooks/useDailyWater"
import { useBodyDisplayUnits } from "features/profile/hooks/body"
import { getDisplayWaterVolume, getWaterUnit } from "utils/waterVolumeConverter"
import { FlexBox } from "components/Common/FlexBox"
import { useNavigate } from "react-router-dom"
import PATHS from "router/paths"
import { WATER_OZ_DECIMAL_PLACE } from "config"
import { getTrimmedDecimalPlaces } from "utils"

const WaterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <path
        d="M14.7334 17.8065L15.2632 22L16.3053 30.2506C16.4316 31.2504 17.2819 32 18.2896 32H25.7104C26.7181 32 27.5684 31.2504 27.6947 30.2506L28.9474 20.3333L29.0526 19.5L29.3073 17.4839M14.7334 17.8065L14 12H30L29.3073 17.4839M14.7334 17.8065C15.6484 17.1613 17.3839 16.5161 19.2174 16.5161C22.3478 16.5161 22.3478 18.4516 24.7826 18.4516C27.2174 18.4516 29.3073 17.4839 29.3073 17.4839M22 22V24.5M22 24.5V27.3846M22 24.5H19.2174M22 24.5H24.7826"
        stroke="#0FBDD4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

interface WaterSectionProps {
  onEditClick: () => void
}

const WaterSection = ({ onEditClick }: WaterSectionProps) => {
  const navigate = useNavigate()
  const { dailyWaterTotal } = useDailyWater()
  const { bodyDisplayUnits } = useBodyDisplayUnits()

  const displayValue = getDisplayWaterVolume(bodyDisplayUnits, dailyWaterTotal)
  const unit = getWaterUnit(bodyDisplayUnits)
  const maxDecimals = unit === "oz" ? WATER_OZ_DECIMAL_PLACE : 0

  return (
    <WaterWrapper style={{ cursor: "pointer" }}>
      <ClickToEditArea onClick={onEditClick}>
        <WaterTitle>water Intake</WaterTitle>
        <WaterValueBox>
          <WaterValue>
            <CountUp
              separator={","}
              style={{ display: "inline-block", lineHeight: "24px" }}
              end={displayValue}
              decimals={getTrimmedDecimalPlaces(displayValue, maxDecimals)}
              duration={0.5}
            ></CountUp>
          </WaterValue>

          <WaterUnit>{unit}</WaterUnit>

          <PencilIcon style={{ width: 24, height: 24, flexShrink: 0 }} />
        </WaterValueBox>
      </ClickToEditArea>

      <FlexBox
        style={{ flexGrow: 1 }}
        $justify="flex-end"
        onClick={() => {
          navigate(PATHS.app.water.root)
        }}
      >
        <WaterIcon />
      </FlexBox>
    </WaterWrapper>
  )
}

export default WaterSection
